var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","md12":"","lg12":"","fill-height":""}},[_c('AdvisorTradeReview')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }